// @ts-check
import React, { useState } from 'react';
import SelectV2 from 'components/Select/SelectV2';
import Tl from 'localization/LocalizationKeys';

const SelectExample = () => {
  const [selected, setSelected] = useState([]);
  return (<SelectV2
    value={selected}
    placeholder={Tl.common.select}
    onChange={setSelected}
    options={[
      { text: 'Option 1', value: '1' },
      { text: 'Option 2', value: '2' },
      { text: 'Option 3', value: '3' }
    ]}
  />);
};

export default SelectExample;

